import { c_producers, CProducer, CProducerId } from '../mdl/c-producer';
import { CProducerRoleInvite, CUserProducerRole } from '../mdl/c-producer-admin';
import { FRoute } from '../mdl/f-route';
import { $location } from '../y/location';
import { $storage } from '../y/storage';
import { haveRoleInProducers } from './can-producer';

declare global {
    interface Window {
        ab_producer_invite?: CProducerRoleInvite;
        ab_routes: FRoute[];
    }
}

export let the_producer: CProducer | undefined;

export function meSetCurrentProducer(producer: CProducer, reload = true) {
    if(the_producer != producer) {
        the_producer = producer;
        if(reload)
            $location.reload();
    }
}

export function meSetDefaultProducer() {
    const producers = haveRoleInProducers('any');
    if(producers.length) {
        const last_producer_id = $storage.getString('last_producer_id') as CProducerId | undefined;
        if(last_producer_id)
            the_producer = c_producers.maybe(last_producer_id);
        if(!the_producer)
            the_producer = c_producers.maybe(producers[0]);
    }
}

declare module '../mdl/c-user' {
    export interface CLoginUser {
        producer_roles: CUserProducerRole[];
    }
}
